import {DocumentAmendment} from "common/flowmaster/types/amendment";

function getOverlappingText(a: string, b: string): string {
  for (let bSliceIdx = b.length; bSliceIdx > 0; bSliceIdx--) {
    const bSlice = b.slice(0, bSliceIdx);
    const overlaps = a.endsWith(bSlice);

    if (overlaps) {
      return bSlice;
    }
  }

  return "";
}

export default function fixDeleteAmendmentOverlappingText(
  amendment: DocumentAmendment,
): DocumentAmendment {
  if (amendment.action_type !== "delete") {
    return amendment;
  }

  const deleted = amendment.deleted_text.trim();

  if (!deleted) {
    return amendment;
  }

  let beforeText = amendment.before_text;
  let afterText = amendment.after_text;

  const overlappingBefore = getOverlappingText(beforeText, deleted);

  if (overlappingBefore) {
    beforeText = beforeText
      .slice(0, beforeText.length - overlappingBefore.length)
      .trim();
  }

  const overlappingAfter = getOverlappingText(deleted, afterText);

  if (overlappingAfter) {
    afterText = afterText
      .slice(overlappingAfter.length + 1, afterText.length)
      .trim();
  }

  if (
    beforeText === amendment.before_text &&
    afterText === amendment.after_text
  ) {
    return amendment;
  }

  return {
    ...amendment,
    before_text: beforeText,
    after_text: afterText,
  };
}
